module.exports = __webpack_public_path__ + "img/logo.420ab1b7.png";